export default __webpack_public_path__ + "static/media/no_delivery.6f3d18c0.png";